import styled from 'styled-components';

import FormControl from './FormControl';
import FormControlGroup from './FormControlGroup';
import FormMessage from './FormMessage';
import FormSubmitter from './FormSubmitter';
import Stack from 'components/Stack/Stack';

const Form = styled(Stack).attrs((props) => ({ ...props, as: 'form' }))`
  font-size: 0.875rem;
  justify-content: start;
  max-width: 100%;
`;

export default Form;

Form.defaultProps = {
  gap: '1rem',
};

Object.assign(Form, {
  Control: FormControl,
  ControlGroup: FormControlGroup,
  Message: FormMessage,
  Submitter: FormSubmitter,
});
